/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit City/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function City({
  children,
  viewPath = "/DesignSystem/DataVaxiomInsuranceCarrierForm/Address/City",
  onChange
  
}) {
let carrierPostalAddressCityValueData = fromData.useDataValue({ viewPath,
context: 'carrier',
path: 'postal_address.city',
})
let carrierPostalAddressCityChangeData = fromData.useDataChange({ viewPath,
context: 'carrier',
path: 'postal_address.city',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="carrier.postal_address.city"
 value={carrierPostalAddressCityValueData}
 onChange={carrierPostalAddressCityChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="City"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}